<template>
    <div>
        <a class="small text-secondary" @click="toggleLMSStepsDisplay()">
            <span class="mr-1">{{ actionText }} LMS-specific steps</span>
            <span
                class="icon icon-100"
                :class="{
                    'icon-glyphicons-basic-chevron-down': !showSteps,
                    'icon-glyphicons-basic-chevron-up': showSteps,
                }"
            ></span>
        </a>
        <div v-show="showSteps" class="mt-3">
            <div class="ml-2">
                <div class="custom-control custom-radio mb-2">
                    <input
                        type="radio"
                        id="lms-steps-d2l"
                        class="custom-control-input"
                        v-model="vendorType"
                        value="d2l"
                    />
                    <label class="custom-control-label mr-1" for="lms-steps-d2l">
                        <span class="badge badge-gray">D2L</span>
                    </label>
                </div>
                <div class="custom-control custom-radio mb-2">
                    <input
                        type="radio"
                        id="lms-steps-canvas"
                        class="custom-control-input"
                        v-model="vendorType"
                        value="canvas"
                    />
                    <label class="custom-control-label mr-1" for="lms-steps-canvas">
                        <span class="badge badge-gray">Canvas</span>
                    </label>
                </div>
                <div class="custom-control custom-radio mb-2">
                    <input
                        type="radio"
                        id="lms-steps-moodle"
                        class="custom-control-input"
                        v-model="vendorType"
                        value="moodle"
                    />
                    <label class="custom-control-label mr-1" for="lms-steps-moodle">
                        <span class="badge badge-gray">Moodle</span>
                    </label>
                </div>
            </div>
            <div class="mt-3 text-secondary medium">
                <ol v-show="vendorType == 'd2l' && organizationId === 545">
                    <li>Navigate to a course.</li>
                    <li>Select <strong>Content</strong> from the navigation bar.</li>
                    <li>Under <strong>Table of Contents</strong>, select <strong>Add a module</strong>.</li>
                    <li>
                        Click on <strong>Existing Activities</strong>, and select
                        <strong>External Learning Tools</strong>.
                    </li>
                    <li>
                        Select <strong>Manage External Learning Tools</strong> and press the
                        <strong>New Link</strong> button.
                    </li>
                    <li>
                        Click on <strong>Manage External Learning Tools</strong> and press <strong>New Link</strong>.
                    </li>
                    <li>
                        Beside <strong>Deployment</strong> select <strong>Affinity</strong>, and paste the LTI Link
                        under <strong>URL</strong>.
                    </li>
                    <li>Give the link a <strong>Name</strong> you'll recognize.</li>
                    <li>Press <strong>Save and Close</strong>, and return to the tab where the course is open.</li>
                    <li>Press the magnifying glass 🔍 icon to refresh the list of LTI Links.</li>
                    <li>Click on the LTI Link you just created to add it to the module.</li>
                    <li v-if="showLaunchStep">Click on the new activity to access Affinity as a learner.</li>
                </ol>
                <ol v-show="vendorType == 'd2l' && organizationId !== 545">
                    <li>Navigate to a course.</li>
                    <li>Select <strong>Content</strong> from the navigation bar.</li>
                    <li>Under <strong>Table of Contents</strong>, select <strong>Add a module</strong>.</li>
                    <li>
                        Select the <strong>Existing Activities</strong> dropdown, and then select
                        <strong>External Learning Tools</strong>.
                    </li>
                    <li>
                        Scroll down to the bottom of the Add Activity window, and select
                        <strong>Create New LTI Link</strong>.
                    </li>
                    <li>
                        Add a title for the link, and paste the LTI Link into the field labeled
                        <strong>LTI URL</strong>.
                    </li>
                    <li>Click <strong>Create and Insert</strong>.</li>
                    <li v-if="showLaunchStep">Click on the new activity to access Affinity as a learner.</li>
                </ol>
                <ol v-show="vendorType == 'canvas'">
                    <li>Navigate to a course.</li>
                    <li>Navigate to the Assignments page, and click <strong>+ Assignment</strong>.</li>
                    <li>Under <strong>Submission Type</strong>, select External Tool.</li>
                    <li>
                        Paste the LTI Link into the field marked
                        <strong>Enter or find an External Tool URL</strong>.
                    </li>
                    <li>Check the box labelled <strong>Load This Tool In A New Tab</strong>.</li>
                    <li>Click <strong>Save</strong>.</li>
                    <li v-if="showLaunchStep">Click on the new activity to access Affinity as a learner.</li>
                </ol>
                <ol v-show="vendorType == 'moodle'">
                    <li>Navigate to a course.</li>
                    <li>Select <strong>+ Add an activity or resource</strong>.</li>
                    <li>Beside <strong>Preconfigured tool</strong>, select 'Automatic, based on tool URL'.</li>
                    <li>
                        Paste the LTI Link into the field marked
                        <strong>Tool URL</strong>.
                    </li>
                    <li>Click <strong>Add</strong>.</li>
                    <li v-if="showLaunchStep">Click on the new activity to access Affinity as a learner.</li>
                </ol>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "LmsInstructions",
    props: {
        showByDefault: {
            type: Boolean,
            default: true,
            required: false,
        },
        defaultVendorType: {
            type: String,
            default() {
                return "d2l"
            },
            required: false,
        },
        showLaunchStep: {
            type: Boolean,
            default: false,
            required: false,
        },
    },
    data() {
        return {
            vendorType: this.defaultVendorType,
            showSteps: this.showByDefault,
        }
    },
    computed: {
        actionText() {
            return this.showSteps ? "Hide" : "Show"
        },
        organizationId() {
            return this.$store.getters.currentOrganizationId
        },
    },
    watch: {
        defaultVendorType: function (val) {
            this.vendorType = val
        },
    },
    methods: {
        toggleLMSStepsDisplay() {
            this.showSteps = !this.showSteps
        },
    },
}
</script>

<style>
</style>